module.exports = __webpack_public_path__ + "img/Cloudy.30af159f.png";